<template>
  <div id="add-fanpage">
    <alert-dynamic-component
      v-if="res == 'berhasil'"
      type="success"
      title="Berhasil!"
      subtitle="Hashtag berhasil ditambahkan."
    />
    <alert-dynamic-component
      v-if="res == 'gagal'"
      type="danger"
      title="Gagal!"
      :subtitle="notif_message"
    />
    <form action="#" v-on:submit.prevent="searchPage">
      <div class="form-group">
        <label for="inputTopik">Nama Halaman Facebook</label>
        <input
          type="text"
          name="halaman"
          v-model="q"
          class="form-control"
          placeholder="Masukkan Nama Halaman Facebook"
          required
        />
      </div>
      <div class="form-group" align="right">
        <button class="btn btn-success">Cari</button>
      </div>
    </form>
    <loader-component v-if="is_loading" />
    <div v-if="result != null && !is_loading" id="result">
      <div v-if="result.length > 0">
        <table class="table">
          <thead>
            <tr>
              <td>Nama Halaman</td>
              <td width="5%">Aksi</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in result" :key="index">
              <td>
                <a
                  class="m-r-5 text-blue"
                  :href="row.link"
                  target="__blank"
                >
                  {{ row.name }}
                </a>
                <span
                  v-if="row.verification_status == 'blue_verified'"
                  class="bi bi-check-circle text-blue"
                ></span>
                <span
                  v-if="row.verification_status == 'gray_verified'"
                  class="bi bi-check-circle"
                ></span>
              </td>
              <td>
                <button
                  @click="addPage(index)"
                  title="Tambahkan Halaman"
                  class="btn btn-sm btn-success"
                >
                  <i class="bi bi-plus"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div align="right" class="m-t-10">
          <button
            v-if="page > 1"
            @click="prev"
            class="btn btn-sm btn-complete m-r-5"
          >
            &laquo; Sebelumnya
          </button>
          <button @click="next" class="btn btn-sm btn-complete">
            Selanjutnya &raquo;
          </button>
        </div>
      </div>
      <div v-else>Halaman tidak ditemukan</div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import loader_component from "@/views/components/loader.vue";
import alert_dynamic from "@/views/components/alert_dynamic.vue";

$.pgNotification = notif;

export default {
  name: "AddFacebookModal",
  components: {
    "loader-component": loader_component,
    "alert-dynamic-component": alert_dynamic,
  },
  data() {
    return {
      q: "",
      result: null,
      paging: null,
      is_loading: false,
      page: 1,
      res: null,
      notif_message: "",
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
    };
  },
  methods: {
    searchPage: function () {
      this.is_loading = true;
      let params = {
        type: "",
        place: "",
        fields: "id,name,verification_status,location,link",
        q: this.q,
        access_token:
          "EAAERQiZAEWKABADr2DAl8pJnxsBsAKEZBMcZCn5f7sZBZCZCJa8E8YfYCQd9UIPUqbSPsCIvxzqxnCZAXrFpjsq4khDaz7xdxp44jMOFsKCqIYyJhg7am4mGY7YAbU2O5N0UkWRoMgHq0W81eMOr8baODxKtkpxT7BZCOoFGojKhUcjK7xZC8JRdAFx2CG1XMUF7HS7QaKZBWqXwZDZD",
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      this.$http
        .get("https://graph.facebook.com/v3.3/pages/search?" + query)
        .then((response) => {
          if (response.status == 200) {
            this.result = response.data.data;
            this.paging = response.data.paging;
          } else {
            this.result = [];
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    next: function () {
      this.$http
        .get(this.paging.next)
        .then((response) => {
          if (response.status == 200) {
            this.result = response.data.data;
            this.paging = response.data.paging;
            this.page = this.page + 1;
          } else {
            this.result = [];
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally((this.is_loading = false));
    },
    prev: function () {
      this.$http
        .get(this.paging.previous)
        .then((response) => {
          if (response.status == 200) {
            this.result = response.data.data;
            this.paging = response.data.paging;
            this.page = this.page - 1;
          } else {
            this.result = [];
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally((this.is_loading = false));
    },
    addPage: function (index_data) {
      let fb_page = this.result[index_data];

      let params = {
        _id: this.id_project,
        page: parseInt(fb_page.id),
        name: fb_page.name,
      };
      this.res = null;
      let api = process.env.VUE_APP_API_URL + "fb-page-add";
      this.$http
        .post(api, params)
        .then((response) => {
          this.$parent.$parent.getFB();
          if (response.status == 200) {
            this.res = "berhasil";
          } else {
            this.res = "gagal";
          }
        })
        .catch((error) => {
          this.notif_message = error.response.data.status;
          this.res = "gagal";
        });
    },
  },
};
</script>